module.exports = __webpack_public_path__ + "img/5_jump_tutorial.20284884.gif";